import { assign, sendParent } from 'xstate';
import { QueryObserver } from '@tanstack/react-query';
import { paymentMethodsCacheKey, queryFnFactory } from '@syf-api-library/payment-methods';
import fetchMachine from './fetchMachine';
const ASSIGN_ACTION = assign({
    paymentMethodsQueryResult: ({ paymentMethodsQueryResult }, event) => {
        const [, data] = event.data;
        return Object.assign(Object.assign({}, paymentMethodsQueryResult), { data });
    }
});
export const sendPaymentMethodsSuccessToParent = sendParent((context, event) => {
    return Object.assign(Object.assign({}, event), { type: 'AFTER_PAYMENT_METHODS_FETCH' });
});
const paymentMethods = {
    type: 'parallel',
    states: {
        querySubscription: {
            invoke: {
                src: ({ apiConfig, queryClient }) => {
                    const queryKey = paymentMethodsCacheKey(apiConfig.keyProps);
                    const queryObserver = new QueryObserver(queryClient, {
                        queryKey,
                        queryFn: queryFnFactory(apiConfig.config, apiConfig.keyProps),
                        enabled: false
                    });
                    const subscribe = (next) => {
                        const unsubscribe = queryObserver.subscribe((event) => {
                            if (event.isLoading === false && event.isSuccess === true) {
                                const data = [queryKey, event.data];
                                next({ type: 'SET_PAYMENT_METHODS', data });
                            }
                        });
                        return {
                            unsubscribe
                        };
                    };
                    return {
                        subscribe
                    };
                }
            }
        },
        api: {
            initial: 'idle',
            states: {
                idle: {},
                fetching: {
                    invoke: {
                        src: fetchMachine,
                        data: {
                            // initialize fetchMachine with context values
                            cacheKey: ({ apiConfig }) => paymentMethodsCacheKey(apiConfig.keyProps),
                            queryClient: ({ queryClient }) => queryClient,
                            queryFn: ({ apiConfig }) => queryFnFactory(apiConfig.config, apiConfig.keyProps)
                        },
                        onDone: {
                            target: 'success',
                            actions: ASSIGN_ACTION
                        },
                        onError: {
                            target: 'error',
                            actions: assign({
                                paymentMethodsQueryResult: ({ paymentMethodsQueryResult }, event) => {
                                    const [, error] = event.data;
                                    return Object.assign(Object.assign({}, paymentMethodsQueryResult), { error });
                                }
                            })
                        }
                    },
                    on: {
                        FETCH_PAYMENT_METHODS: undefined
                    }
                },
                success: {
                    entry: 'sendPaymentMethodsSuccessToParent'
                },
                error: {
                    entry: 'sendErrorToParent'
                }
            }
        }
    },
    on: {
        FETCH_PAYMENT_METHODS: {
            target: '#apiMachine.paymentMethods.api.fetching',
            actions: assign({
                paymentMethodRefreshCount: ({ apiConfig, paymentMethodRefreshCount, queryClient }, { force }) => {
                    if (force) {
                        queryClient.invalidateQueries(paymentMethodsCacheKey(apiConfig.keyProps));
                    }
                    return (paymentMethodRefreshCount || 0) + 1;
                }
            })
        },
        SET_PAYMENT_METHODS: {
            target: '#apiMachine.paymentMethods.api.success',
            actions: ASSIGN_ACTION
        }
    }
};
export default paymentMethods;
